// Défauts d'une ligne d'import Tradovate face au modèle de tarification.
//
// Module PUR (aucun import Wasp/React), même raison que tradovateImportCost.ts :
// importer TradovateImportReview.tsx depuis un test tire `wasp/client/operations`,
// qui touche `window` et fait échouer vitest ("window is not defined").

import { isDirectFunded } from "../pricingModel";
import type { AccountStatus } from "../accountStatus";

/**
 * Statut initial d'une ligne d'import pour un compte NEUF (inconnu d'Edgely).
 *
 * Un compte déjà connu n'y passe pas : il reprend son statut Edgely réel
 * (`existing.status`, renvoyé par `listTradovateAccountsForImport`), que
 * l'import ne modifie pas. Un compte de l'hôte live est proposé "live"
 * (programme live). Ailleurs "challenge" reste le défaut
 * historique, SAUF si le palier suggéré est direct funded : ce modèle n'a
 * jamais de phase de challenge (le serveur refuse la création), donc proposer
 * "challenge" par défaut mènerait l'utilisateur droit dans l'erreur.
 */
export function initialImportStatus(
  suggestedTierPricingModel: unknown,
  apiEnv?: string | null,
): AccountStatus {
  // L'hôte live ne porte que de l'argent réel : jamais un challenge ni un
  // funded sim (le parc prop firm simulé vit sur l'hôte demo). Sous une prop
  // firm c'est son programme live (phase `live` du palier) ; sans prop firm,
  // un compte perso réel. Dans les deux cas "live" est la bonne réponse.
  if (apiEnv === "live") return "live";
  return isDirectFunded(suggestedTierPricingModel) ? "pa" : "challenge";
}
